<div class="row">
  <div class="col">
    <h3>{{ 'i18n.domain.client-administration.overview.title' | translate }}</h3>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div  class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive" cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
    class="grid-with-toolbar"
    width='100%'
    rowHeight='38'
    [dataSource]='data'
    [allowSorting]='true'
    [filterSettings]='filterSettings'
    [allowFiltering]='true'
    [allowPaging]='true'
    [pageSettings]='pageSettings'
    [editSettings]='editSettings'
    [searchSettings]="searchOptions"
    (actionBegin)="actionBegin($event)"
    (actionComplete)="actionComplete($event)"
    (commandClick)="commandClick($event)">
    <ng-template #toolbarTemplate let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.client-administration.overview.add' | translate" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      @for (column of gridColumns; track column.field) {
        <e-column
          [headerText]='column.headerKey | translate'
          [field]='column.field'
          [type]='column.type ?? "string"'
          [visible]='isColumnVisible(column.field, column.visible)'
          [width]='column.width'
          [clipMode]='column.clipMode'
          [isPrimaryKey]='isPrimaryKeyColumn(column.field)'
          [allowFiltering]='isFilteringAllowed(column.allowFiltering)'
          [filter]='getColumnFilter(column.field, column.allowFiltering)'>
          @if (column.filter?.kind === 'boolean') {
            <ng-template #filterItemTemplate let-data>{{formatBooleanFilter(data, column.field, column.filter) | translate}}</ng-template>
            <ng-template #template let-data>
              @if (data[column.field]) {
                <div class="e-icons icon-checkmark align-middle"></div>
              }
            </ng-template>
          } @else if (column.filter?.kind === 'enum') {
            <ng-template #filterItemTemplate let-data>{{formatFilter(data, column.field, column.filter) | translate}}</ng-template>
              <ng-template #template let-data>
                <span>{{formatColumnValue(column.field, data)}}</span>
              </ng-template>
          }
        </e-column>
      }
      <e-column headerText="" [commands]='gridCommands'></e-column>
    </e-columns>
    <ng-template #editSettingsTemplate let-data>
      <app-dynamic-edit-form
        [formGroup]="gridEditForm"
        [fields]="crudDefinition.form.fields"
        [layout]="crudDefinition.form.layout"
        [isEditMode]="isEditMode"
        [initialReferenceItems]="referenceInitialItems">
      </app-dynamic-edit-form>
    </ng-template>
  </ejs-grid>
</div>
